// import React, { useState, useEffect } from "react";
// import {
//   Backdrop,
//   Button,
//   FormFieldSet,
//   LogoLoader,
//   showToast,
//   useFormHandler,
// } from "../../../../../../components";
// import ChromeLogo from "../../../../../../assets/logos/chrome_logo.svg";
// import GmailLogo from "../../../../../../assets/logos/gmail_logo.svg";
// import MobileLogo from "../../../../../../assets/logos/mobile_phone_logo.svg";
// import Office365Logo from "../../../../../../assets/logos/office365_logo.svg";
// import OutlookLogo from "../../../../../../assets/logos/outlook_logo.svg";
// import ParserLogo from "../../../../../../assets/logos/parser_logo.svg";
// import { useNavigate, useLocation } from "react-router-dom";
// import { useSelector } from "react-redux";
// import {
//   addUser,
//   getUser,
//   updateUser,
// } from "../../../../../../redux/slices/setting/settingApi";

// // const plugins = [
// //   {
// //     image: ChromeLogo,
// //     lable: "Chrome",
// //   },
// //   {
// //     image: GmailLogo,
// //     lable: "Gmail",
// //   },
// //   {
// //     image: MobileLogo,
// //     lable: "Mobile",
// //   },
// //   {
// //     image: Office365Logo,
// //     lable: "Office365",
// //   },
// //   {
// //     image: OutlookLogo,
// //     lable: "Outlook",
// //   },
// //   {
// //     image: ParserLogo,
// //     lable: "Quick Parser",
// //   },
// // ];
// // Add numeric value for each plugin
// const plugins = [
//   {
//     image: ChromeLogo,
//     lable: "Chrome",
//     value: 1,
//   },
//   {
//     image: GmailLogo,
//     lable: "Gmail",
//     value: 2,
//   },
//   {
//     image: MobileLogo,
//     lable: "Mobile",
//     value: 3,
//   },
//   {
//     image: Office365Logo,
//     lable: "Office365",
//     value: 4,
//   },
//   {
//     image: OutlookLogo,
//     lable: "Outlook",
//     value: 5,
//   },
//   {
//     image: ParserLogo,
//     lable: "Quick Parser",
//     value: 6,
//   },
// ];

// const countrys = [
//   { label: "India", value: "India" },
//   { label: "Pakistan", value: "Pakistan" },
//   { label: "USA", value: "USA" },
// ];

// const states = [
//   { label: "Telangana", value: "Telangana" },
//   { label: "Andhra Pradesh", value: "Andhra Pradesh" },
//   { label: "Karnataka", value: "Karnataka" },
// ];

// const userDesignation = [
//   { label: "CEO", value: "CEO" },
//   { label: "CTO", value: "CTO" },
//   { label: "Manager", value: "Manager" },
// ];
// // const designations = [
// //   { label: "JUNIOR", value: 1 },
// //   { label: "SENIOR", value: 2 },
// //   { label: "LEAD", value: 3 },
// //   { label: "MANAGER", value: 4 },
// //   { label: "EMPLOYEE", value: 5 },
// // ];
// const designations = [
//   { label: "JUNIOR", value: "JUNIOR" },
//   { label: "SENIOR", value: "SENIOR" },
//   { label: "LEAD", value: "LEAD" },
//   { label: "MANAGER", value: "MANAGER" },
//   { label: "EMPLOYEE", value: "EMPLOYEE" },
// ];

// const roles = [
//   { label: "CEO", value: "CEO" },
//   { label: "CTO", value: "CTO" },
//   { label: "Manager", value: "Manager" },
// ];

// const teams = [
//   { label: "RA Manager", value: 1 },
//   { label: "RA Lead", value: 2 },
//   { label: "RA Associate", value: 3 },
// ];

// //for temporary purpose
// const atsRoles = [
//   { label: "RA Analyst", value: 1 },
//   { label: "RA Lead", value: 2 },
//   { label: "RA Manager", value: 3 },
// ];

// const workforceRoles = [
//   { label: "WF Admin", value: 1 },
//   { label: "WF Manager", value: 2 },
//   { label: "WF User", value: 3 },
// ];

// const levelOptions = [
//   { label: "Fresher", value: 1 },
//   { label: "Junior", value: 2 },
//   { label: "Senior", value: 3 },
//   { label: "Lead", value: 4 },
//   { label: "Manager", value: 5 },
// ];

// const AddUser = ({}) => {
//   const [validationRules, setValidationRules] = useState();
//   const [selectedPlugins, setSelectedPlugins] = useState([]);
//   const { user } = useSelector((state) => state.auth);
//   const navigate = useNavigate();
//   const location = useLocation();
//   const { isEdit, data, returnTo } = location.state || false;
//   const [loading, setLoading] = useState(false);

//   const initialFormData = {
//     firstName: "",
//     lastName: "",
//     emailId: "",
//     // phoneNumber: data?.mobile || "",
//     phone: { code: "", number: "" },
//     country: "",
//     state: "",
//     city: "",
//     designation: "",
//     role: "",
//     // roleType: "",
//     team: "",
//     reportingTo: "",
//     level: "",
//     // teamRole: "",
//     roleType: [],
//     teamRole: [],

//     // userDesignation : ""
//   };

//   useEffect(() => {
//     const baseRules = {
//       firstName: {
//         type: "text",
//         required: true,
//       },
//       lastName: {
//         type: "text",
//         required: true,
//       },
//       emailId: {
//         type: "text",
//         required: true,
//       },
//       country: { type: "select", required: true },
//       roleType: { type: "text", required: true },
//       role: { type: "select", required: true },
//       reportingTo: { type: "select", required: true },
//       // phoneNumber: {
//       //   type: "text",
//       //   required: true,
//       // },
//       // country: {
//       //   type: "text",
//       //   required: true,
//       // },
//       // state: {
//       //   type: "text",
//       //   required: true,
//       // },
//     };
//     setValidationRules(baseRules);
//   }, []);

//   const { formData, errors, handleChange, validateAllFields, setFormData } =
//     useFormHandler(initialFormData, validationRules);
//   function generatePassword(length = 10) {
//     const upper = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
//     const lower = "abcdefghijklmnopqrstuvwxyz";
//     const numbers = "0123456789";
//     const specials = "&()#*$@";

//     // make sure at least one from each category
//     let password = [
//       upper[Math.floor(Math.random() * upper.length)],
//       lower[Math.floor(Math.random() * lower.length)],
//       numbers[Math.floor(Math.random() * numbers.length)],
//       specials[Math.floor(Math.random() * specials.length)],
//     ];

//     const allChars = upper + lower + numbers + specials;

//     // fill remaining characters
//     for (let i = password.length; i < length; i++) {
//       password.push(allChars[Math.floor(Math.random() * allChars.length)]);
//     }

//     // shuffle to avoid predictable pattern
//     password = password.sort(() => Math.random() - 0.5);

//     return password.join("");
//   }
//   // const handleSubmit = async () => {
//   //   const isValid = await validateAllFields();
//   // };
//   const handleSubmit = async (status) => {
//     const isValid = validateAllFields();
//     if (!isValid) return;

//     const payload = {
//       organizationId: user.data.organizationId.uiid,
//       firstName: formData.firstName,
//       lastName: formData.lastName,
//       // mobile: {
//       //   // primary: formData.phoneNumber,
//       //   // countryCode: "+91"
//       //   primary: {
//       //     code: formData.phone?.code,
//       //     number: formData.phone?.number,
//       //   },
//       // },
//       ...(formData.phone?.number
//         ? {
//             mobile: {
//               primary: {
//                 code: formData.phone?.code,
//                 number: formData.phone?.number,
//               },
//             },
//           }
//         : {}),
//       address: {
//         country: formData.country?.value,
//         state: formData.state?.value,
//         city: formData.city?.value,
//       },
//       email: {
//         primary: formData.emailId,
//       },
//       ...(isEdit ? {} : { password: generatePassword() }),
//       profilePhotoUrl: "https://api.dicebear.com/9.x/micah/svg?seed=Leo",
//       // role: Number(formData.role.roleType) || 2, // Not decided so passing 2 for RA
//       // designation: Number(formData.designation),
//       team: Number(formData.team),
//       teamRole: Number(formData.teamRole),
//       // reportingTo: Number(formData.reportingTo.value),
//       reportTo: Number(formData.reportingTo.value),
//       // level: Number(formData.level),
//       ...(formData.level ? { level: Number(formData.level) } : {}),
//       pluginAccess: selectedPlugins,
//       addedBy: user.data?.uiid,
//       status: isEdit ? formData.status : status,
//       // userDesignation : formData.userDesignation,
//       designation: formData.designation,
//       // roleId: formData.role.roleType,
//       // roleId: formData.role.value,
//       role: formData.role.value,
//       // role: formData.role.type,
//     };

//     try {
//       setLoading(true);
//       let res;
//       if (isEdit && formData._id) {
//         res = await updateUser({
//           id: formData._id,
//           payload: { $set: payload },
//         });
//       } else {
//         res = await addUser({
//           coll: "User",
//           payload,
//         });
//       }
//       if (res?.data) {
//         if (isEdit) {
//           showToast("User updated successfully!", "success", 2000);
//         } else {
//           showToast("User added successfully!", "success", 2000);
//           setFormData(initialFormData);
//         }
//         // navigate("/settings#access-control");
//         navigate(
//           "/settings?access-control=user-teams&settings=access-control#access-control"
//         );
//       } else {
//         // showToast(res.error || "An error occured", "error", 2000);
//         const errorMsg =
//           typeof res?.error === "string" ? res?.error : "An error occurred";

//         showToast(errorMsg, "error", 2000);
//       }
//     } catch (err) {
//       console.error("Error adding user:", err);
//     } finally {
//       setLoading(false);
//     }
//   };
//   const handlePlugins = (key) => {
//     let newPlugins = [];
//     if (selectedPlugins.includes(key)) {
//       newPlugins = selectedPlugins.filter((item) => item !== key);
//     } else {
//       newPlugins = [...selectedPlugins, key];
//     }

//     setSelectedPlugins(newPlugins);
//   };

//   useEffect(() => {
//     const fetchUser = async () => {
//       if (isEdit && data?.uiid) {
//         try {
//           setLoading(true);
//           const res = await getUser({
//             coll: "User",
//             fil: { uiid: { type: "IN", value: data.uiid } },
//             // ref: "Role User"
//             ref: "reportTo Role",
//           });

//           if (res?.data?.data) {
//             const userData = res.data.data;
//             // const roleObj = userData.role?.[0];
//             const roleObj = userData.role;
//             //         setFormData({
//             //           firstName: userData.firstName || "",
//             //           lastName: userData.lastName || "",
//             //           emailId: userData.email?.primary || "",
//             //           phone: userData.mobile?.primary || { code: "+91", number: "" },
//             //           // country: { label: userData.address?.country, value: userData.address?.country },
//             //           // state: { label: userData.address?.state, value: userData.address?.state },
//             //           // city: { label: userData.address?.city, value: userData.address?.city },
//             //           country: userData.address?.country
//             //   ? { label: userData.address.country, value: userData.address.country }
//             //   : "",
//             // state: userData.address?.state
//             //   ? { label: userData.address.state, value: userData.address.state }
//             //   : "",
//             // city: userData.address?.city
//             //   ? { label: userData.address.city, value: userData.address.city }
//             //   : "",
//             //           designation: userData.designation || "",
//             //           role: { value: userData.roleId }, // map properly
//             //           // roleType: userData.roleType === 1 ? "ATS" : "Workforce", // example logic
//             //           team: userData.team || "",
//             //           reportingTo: { value: userData.reportingTo },
//             //           level: userData.level || "",
//             //           // teamRole: userData.teamRole || "",
//             //           roleType: userData.roleType
//             //   ? [userData.roleType === 1 ? "ATS" : "Workforce"]
//             //   : [],

//             // teamRole: userData.teamRole
//             //   ? [String(userData.teamRole)]
//             //   : [],
//             //         });
//             setFormData({
//               _id: userData._id,
//               firstName: userData?.firstName || "",
//               lastName: userData?.lastName || "",
//               emailId: userData.email?.primary || "",
//               phone: userData.mobile?.primary || { code: "+1", number: "" },
//               country: userData.address?.country
//                 ? {
//                     label: userData.address.country,
//                     value: userData.address.country,
//                   }
//                 : "",
//               state: userData.address?.state
//                 ? {
//                     label: userData.address.state,
//                     value: userData.address.state,
//                   }
//                 : "",
//               city: userData.address?.city
//                 ? { label: userData.address.city, value: userData.address.city }
//                 : "",
//               designation: userData?.designation || "",
//               // role: userData.role ? { value: userData.role } : null,
//               // roleType: userData.roleType
//               //   ? [userData.roleType === 1 ? "ATS" : "Workforce"]
//               //   : [],
//               //   roleType: roleObj
//               // ? roleObj?.module === 1 ? "ATS" : "Workforce"
//               // : "",
//               roleType: roleObj
//                 ? roleObj?.module === 2
//                   ? "ATS"
//                   : roleObj?.module === 3
//                   ? "Workforce"
//                   : ""
//                 : "ALL",
//               role: roleObj
//                 ? { value: roleObj.uiid, label: roleObj.name }
//                 : null,
//               team: userData.team || "",
//               // reportingTo: `${userData.reportingTo?.[0]?.firstName || ""} ${userData.reportingTo?.[0]?.lastName || ""}`,
//               // reportingTo: userData.reportingTo?.[0]
//               // ? {
//               //     value: userData.reportingTo[0].uiid,
//               //     label: `${userData.reportingTo[0].firstName} ${userData.reportingTo[0].lastName}`,
//               //   }
//               // : null,
//               reportingTo: userData.reportTo?.[0]
//                 ? {
//                     value: userData.reportTo[0].uiid,
//                     label: `${userData.reportTo[0].firstName} ${userData.reportTo[0].lastName}`,
//                   }
//                 : null,
//               // reportingTo: userData
//               // ? userData.reportingTo
//               // : null,
//               level: userData.level || "",
//               teamRole: userData.teamRole ? String(userData.teamRole) : "",
//               status: userData.status,
//             });

//             // Set selected plugins
//             setSelectedPlugins(userData.pluginAccess || []);
//           }
//         } catch (error) {
//           console.error("Error fetching user:", error);
//         } finally {
//           setLoading(false);
//         }
//       }
//     };

//     fetchUser();
//   }, [isEdit, data, setFormData]);

//   return (
//     <div className="flex flex-col gap-2 mt-4">
//       <div className="flex items-center gap-2">
//         <Button
//           // type="icon"
//           variant="text"
//           title={isEdit && isEdit ? "Edit User" : "Add User"}
//           icon="arrow_left_alt"
//           color="black"
//           fromLeft
//           className="self-start text-lg font-semibold !px-2"
//           onClick={() => {
//             if (returnTo) {
//               navigate("/bs/benchsales/recruiters");
//             } else {
//               navigate(
//                 "/settings?access-control=user-teams&settings=access-control#access-control"
//               );
//             }
//           }}
//         />

//         {/* <h6>{isEdit && isEdit ? "Edit" : "Add"} User</h6> */}
//       </div>
//       <div className="flex flex-col rounded shadow m-1 p-3">
//         <h6>User Information</h6>
//         <hr className="text-primary w-15 mt-1" />

//         <div className="grid grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 gap-3 py-2">
//           <FormFieldSet
//             title="First Name"
//             type="text"
//             placeholder="Enter"
//             value={formData.firstName}
//             onChange={(value) => handleChange("firstName", value)}
//             error={errors.firstName}
//             shadow={true}
//           />
//           <FormFieldSet
//             title="Last Name"
//             type="text"
//             placeholder="Enter"
//             value={formData.lastName}
//             onChange={(value) => handleChange("lastName", value)}
//             error={errors.lastName}
//             shadow={true}
//           />
//           <FormFieldSet
//             title="Email ID"
//             type="text"
//             placeholder="Enter"
//             value={formData.emailId}
//             onChange={(value) => handleChange("emailId", value)}
//             error={errors.emailId}
//             shadow={true}
//           />
//           {/* <FormFieldSet
//             title="Phone Number"
//             // type="text"
//             type="phoneNew"
//             placeholder="Enter"
//             // value={formData.phoneNumber}
//             values={[formData.phone]}
//             // onChange={(value) => handleChange("phone.number", value[0])}
//             onChange={(value) => {
//               // value[0] will be the phone object { code, number }
//               handleChange("phone", value[0]);
//             }}
//             error={errors.phoneNumber}
//             shadow={true}
//           /> */}
//           <FormFieldSet
//             title="Phone Number"
//             type="phone"
//             placeholder="Enter Mobile Number"
//             // value={
//             //   formData.phone?.fullNumber ||
//             //   (formData.phone?.code && formData.phone?.number
//             //     ? `${formData.phone.code}${formData.phone.number}`
//             //     : "")
//             // }
//             value={formData.phone?.number || ""}
//             code={formData.phone?.code || ""}
//             onChange={(fullValue, details) =>
//               handleChange("phone", {
//                 code: details.countryCode,
//                 number: details.number,
//                 fullNumber: details.fullNumber,
//               })
//             }
//             error={errors.phone}
//             shadow={true}
//           />
//           <div className="w-full">
//             <FormFieldSet
//               title="Country"
//               // type="select"
//               type="countriesUsAndCanada"
//               placeholder="Select"
//               // options={countrys}
//               value={formData.country}
//               onChange={(value) => handleChange("country", value)}
//               error={errors.country}
//               shadow={true}
//             />
//           </div>
//           <FormFieldSet
//             title="State"
//             showSearch
//             type="states"
//             // type="select"
//             placeholder="Select"
//             // options={states}
//             value={formData.state}
//             onChange={(value) => handleChange("state", value)}
//             parentValue={{ country: formData?.country?.value }}
//             disabled={!formData.country}
//             error={errors.state}
//             shadow={true}
//           />
//           <FormFieldSet
//             title="City"
//             // type="text"
//             type="cities"
//             showSearch
//             placeholder="Enter"
//             value={formData.city}
//             onChange={(value) => handleChange("city", value)}
//             error={errors.city}
//             parentValue={{
//               country: formData.country?.value,
//               state: formData.state?.value,
//             }}
//             disabled={!formData.state}
//             shadow={true}
//           />
//           <FormFieldSet
//             title="Designation"
//             type="select"
//             placeholder="Select"
//             options={designations}
//             value={formData.designation}
//             onChange={(value) => handleChange("designation", value)}
//             error={errors.designation}
//             shadow={true}
//           />
//           <FormFieldSet
//             title="Level"
//             type="select"
//             placeholder="Select"
//             options={levelOptions}
//             value={formData.level}
//             onChange={(value) => handleChange("level", value)}
//             error={errors.level}
//             shadow={true}
//           />
//           {/* <FormFieldSet
//             title="User Designation"
//             type="select"
//             placeholder="Select"
//             options={userDesignation}
//             value={formData.userDesignation}
//             onChange={(value) => handleChange("Userdesignations", value)}
//             error={errors.userDesignation}
//           /> */}
//         </div>
//       </div>

//       <div className="grid grid-cols-2 gap-2">
//         <div className="flex flex-col rounded shadow m-1 p-3">
//           <h6>Role Selection</h6>
//           <hr className="text-primary w-15 mt-1" />

//           <div className="flex flex-col py-2">
//             <FormFieldSet
//               type="checkbox"
//               //  type="radio"
//               size="md"
//               options={[
//                 { label: "ATS", value: "ATS" },
//                 {
//                   label: "Workforce",
//                   value: "Workforce",
//                 },
//                 {
//                   label: "Benchsales",
//                   value: "Benchsales",
//                 },
//               ]}
//               values={formData.roleType}
//               onChange={(value) => handleChange("roleType", value)}
//               error={errors.roleType}
//               noTitle
//               multiple={false}
//             />
//             <div className="w-[30%] my-2">
//               <FormFieldSet
//                 // type="select"
//                 type={
//                   formData.roleType === "ATS"
//                     ? "atsRoles"
//                     : formData.roleType === "Workforce"
//                       ? "workforceRoles"
//                       : formData.roleType === "Benchsales"
//                         ? "benchsalesRoles"
//                         : []
//                 }
//                 title="Select Role"
//                 placeholder="Select"
//                 // options={roles}
//                 // options={
//                 //   formData.roleType === "ATS"
//                 //     ? atsRoles
//                 //     : formData.roleType === "Workforce"
//                 //     ? workforceRoles
//                 //     : []
//                 // }
//                 value={formData.role}
//                 onChange={(value) => {
//                   // console.log("value",value)
//                   handleChange("role", value);
//                 }}
//                 error={errors.role}
//                 disabled={!formData.roleType}
//                 shadow={true}
//               />
//             </div>
//           </div>
//         </div>

//         <div className="flex flex-col rounded shadow p-3">
//           {/* <h6>Reporting To</h6>
//           <hr className="text-primary w-15 mt-1" /> */}

//           {/* <div className="flex flex-col py-2"> */}
//           <div className="w-[30%] mb-5">
//             <FormFieldSet
//               // type="select"
//               type="users"
//               title="Reporting To"
//               placeholder="Select"
//               // options={teams}
//               value={formData.reportingTo}
//               onChange={(value) => {
//                 handleChange("reportingTo", value);
//               }}
//               error={errors.reportingTo}
//               shadow={true}
//               showSearch
//             />
//           </div>
//           <div className="flex items-end gap-5">
//             <div className="w-[30%]">
//               <FormFieldSet
//                 type="select"
//                 title="Select Team"
//                 placeholder="Select"
//                 options={teams}
//                 value={formData.team}
//                 onChange={(value) => handleChange("team", value)}
//                 error={errors.team}
//                 shadow={true}
//               />
//             </div>

//             <FormFieldSet
//               type="checkbox"
//               // type="radio"
//               size="md"
//               // options={[
//               //   { label: "Team Lead", value: "Team Lead" },
//               //   {
//               //     label: "Team Member",
//               //     value: "Team Member",
//               //   },
//               // ]}
//               options={[
//                 { label: "Team Lead", value: "1" },
//                 {
//                   label: "Team Member",
//                   value: "2",
//                 },
//               ]}
//               values={formData.teamRole}
//               // onChange={(value) => handleChange("reportingTo", value)}
//               onChange={(val) => {
//                 handleChange("teamRole", val);
//               }}
//               // onChange={(e) => handleChange("reportingTo",e.target)}
//               error={errors.teamRole}
//               noTitle
//               multiple={false}
//             />
//           </div>
//           {/* </div> */}
//         </div>
//       </div>

//       <div className="flex flex-col rounded shadow m-1 p-3">
//         <h6>Set Plugin Access Permissions</h6>
//         <hr className="text-primary w-15 mt-1" />

//         <div className="flex gap-3 my-3">
//           {plugins.map((value, key) => (
//             <Button
//               key={key}
//               className={`!border-gray-300 !text-black ${
//                 // selectedPlugins.includes(key) ? `!bg-primary-50` : `!bg-gray-50`
//                 selectedPlugins.includes(value.value)
//                   ? `!bg-primary-50`
//                   : `!bg-gray-50`
//               }`}
//               title={
//                 <div className="flex gap-3">
//                   <img src={value.image} alt={`${value.lable} logo`} />
//                   <span>{value.lable}</span>
//                 </div>
//               }
//               // onClick={() => handlePlugins(key)}
//               onClick={() => handlePlugins(value.value)}
//             />
//           ))}
//         </div>
//       </div>

//       <div className="flex gap-3 self-end mt-1">
//         <Button
//           title="Cancel"
//           variant="outlined"
//           onClick={() => navigate("/settings#access-control")}
//         />
//         {isEdit && isEdit ? (
//           <Button title="Save" onClick={handleSubmit} />
//         ) : (
//           <>
//             <Button
//               title="Register"
//               // onClick={handleSubmit}
//               onClick={() => handleSubmit(2)}
//             />
//             <Button
//               title="Register & Activate"
//               // onClick={handleSubmit}
//               onClick={() => handleSubmit(1)}
//             />
//           </>
//         )}
//       </div>
//       <Backdrop isOpen={loading}>
//         <LogoLoader />
//       </Backdrop>
//     </div>
//   );
// };

// export default AddUser;

import React, { useState, useEffect } from "react";
import { v4 as uuidv4 } from "uuid";
import {
  Backdrop,
  Button,
  FormFieldSet,
  LogoLoader,
  showToast,
  useFormHandler,
} from "../../../../../../components";
import ChromeLogo from "../../../../../../assets/logos/chrome_logo.svg";
import GmailLogo from "../../../../../../assets/logos/gmail_logo.svg";
import MobileLogo from "../../../../../../assets/logos/mobile_phone_logo.svg";
import Office365Logo from "../../../../../../assets/logos/office365_logo.svg";
import OutlookLogo from "../../../../../../assets/logos/outlook_logo.svg";
import ParserLogo from "../../../../../../assets/logos/parser_logo.svg";
import { useNavigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import {
  addUser,
  getUser,
  updateUser,
} from "../../../../../../redux/slices/setting/settingApi";
import { trackEvent } from "../../../../../../utils/mixpanelService";
import { useLoginUser } from "../../../../../../hooks/useLoginUser";

// const plugins = [
//   {
//     image: ChromeLogo,
//     lable: "Chrome",
//   },
//   {
//     image: GmailLogo,
//     lable: "Gmail",
//   },
//   {
//     image: MobileLogo,
//     lable: "Mobile",
//   },
//   {
//     image: Office365Logo,
//     lable: "Office365",
//   },
//   {
//     image: OutlookLogo,
//     lable: "Outlook",
//   },
//   {
//     image: ParserLogo,
//     lable: "Quick Parser",
//   },
// ];
// Add numeric value for each plugin
const plugins = [
  {
    image: ChromeLogo,
    lable: "Chrome",
    value: 1,
  },
  {
    image: GmailLogo,
    lable: "Gmail",
    value: 2,
  },
  {
    image: MobileLogo,
    lable: "Mobile",
    value: 3,
  },
  {
    image: Office365Logo,
    lable: "Office365",
    value: 4,
  },
  {
    image: OutlookLogo,
    lable: "Outlook",
    value: 5,
  },
  {
    image: ParserLogo,
    lable: "Quick Parser",
    value: 6,
  },
];

const countrys = [
  { label: "India", value: "India" },
  { label: "Pakistan", value: "Pakistan" },
  { label: "USA", value: "USA" },
];

const states = [
  { label: "Telangana", value: "Telangana" },
  { label: "Andhra Pradesh", value: "Andhra Pradesh" },
  { label: "Karnataka", value: "Karnataka" },
];

const userDesignation = [
  { label: "CEO", value: "CEO" },
  { label: "CTO", value: "CTO" },
  { label: "Manager", value: "Manager" },
];
// const designations = [
//   { label: "JUNIOR", value: 1 },
//   { label: "SENIOR", value: 2 },
//   { label: "LEAD", value: 3 },
//   { label: "MANAGER", value: 4 },
//   { label: "EMPLOYEE", value: 5 },
// ];
const designations = [
  { label: "JUNIOR", value: "JUNIOR" },
  { label: "SENIOR", value: "SENIOR" },
  { label: "LEAD", value: "LEAD" },
  { label: "MANAGER", value: "MANAGER" },
  { label: "EMPLOYEE", value: "EMPLOYEE" },
];

const roles = [
  { label: "CEO", value: "CEO" },
  { label: "CTO", value: "CTO" },
  { label: "Manager", value: "Manager" },
];

const teams = [
  { label: "RA Manager", value: 1 },
  { label: "RA Lead", value: 2 },
  { label: "RA Associate", value: 3 },
];

//for temporary purpose
const atsRoles = [
  { label: "RA Analyst", value: 1 },
  { label: "RA Lead", value: 2 },
  { label: "RA Manager", value: 3 },
];

const workforceRoles = [
  { label: "WF Admin", value: 1 },
  { label: "WF Manager", value: 2 },
  { label: "WF User", value: 3 },
];

const levelOptions = [
  { label: "Fresher", value: 1 },
  { label: "Junior", value: 2 },
  { label: "Senior", value: 3 },
  { label: "Lead", value: 4 },
  { label: "Manager", value: 5 },
];

const BENCH_USER_MODULE = 4;
const AddUser = ({}) => {
  const [validationRules, setValidationRules] = useState();
  const [selectedPlugins, setSelectedPlugins] = useState([]);
  const { user } = useSelector((state) => state.auth);
  const navigate = useNavigate();
  const location = useLocation();
  const { isEdit, data, returnTo } = location.state || false;
  const [loading, setLoading] = useState(false);

  // for benchsales cis we are hiding the roles of ats and workforce
  const { userData: loginUserData } = useLoginUser();
  const moduleNumber = loginUserData?.role?.module;
  const isBenchUser = BENCH_USER_MODULE === moduleNumber;

  const initialFormData = {
    firstName: "",
    lastName: "",
    emailId: "",
    // phoneNumber: data?.mobile || "",
    phone: { code: "", number: "" },
    country: "",
    state: "",
    city: "",
    designation: "",
    role: "",
    // roleType: "",
    team: "",
    reportingTo: "",
    level: "",
    // teamRole: "",
    roleType: [],
    teamRole: [],
    userType: "",
    botAssignedTo: []

    // userDesignation : ""
  };
  const { formData, errors, handleChange, validateAllFields, setFormData } =
    useFormHandler(initialFormData, validationRules);
  const isNormalUser = Number(formData.userType) !== 2;

  useEffect(
    () => {
      let rules = {
        firstName: {
          type: "text",
          required: true,
        },
        lastName: {
          type: "text",
          required: true,
        },
        emailId: {
          type: "text",
          required: true,
        },
        phone: {
          type: "phone",
          required: true,
        },
        country: {
          type: "select",
          required: true,
        },
        roleType: {
          type: "text",
          required: true,
        },
        role: {
          type: "select",
          required: true,
        },
        reportingTo: {
          type: "select",
          required: true,
        },
      };

      if (Number(formData.userType) === 2) {
        handleChange("roleType", "ATS");
        handleChange("role",{value:4,label:"Recruiter"});
      }
      else{
        handleChange("roleType", []);
        handleChange("role","");
      }

      setValidationRules(rules);
    },
    [
      isNormalUser
    ],
  );

  function generatePassword(length = 10) {
    const upper = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    const lower = "abcdefghijklmnopqrstuvwxyz";
    const numbers = "0123456789";
    const specials = "&()#*$@";

    // make sure at least one from each category
    let password = [
      upper[Math.floor(Math.random() * upper.length)],
      lower[Math.floor(Math.random() * lower.length)],
      numbers[Math.floor(Math.random() * numbers.length)],
      specials[Math.floor(Math.random() * specials.length)],
    ];

    const allChars = upper + lower + numbers + specials;

    // fill remaining characters
    for (let i = password.length; i < length; i++) {
      password.push(allChars[Math.floor(Math.random() * allChars.length)]);
    }

    // shuffle to avoid predictable pattern
    password = password.sort(() => Math.random() - 0.5);

    return password.join("");
  }
  // const handleSubmit = async () => {
  //   const isValid = await validateAllFields();
  // };
  const handleSubmit = async (status) => {
    const isValid = validateAllFields();
    if (!isValid) return;

    const payload = {
      organizationId: user.data.organizationId.uiid,
      firstName: formData.firstName,
      lastName: formData.lastName,
      // mobile: {
      //   // primary: formData.phoneNumber,
      //   // countryCode: "+91"
      //   primary: {
      //     code: formData.phone?.code,
      //     number: formData.phone?.number,
      //   },
      // },
      ...(formData.phone?.number
        ? {
            mobile: {
              primary: {
                code: formData.phone?.code,
                number: formData.phone?.number,
              },
            },
          }
        : {}),
      address: {
        country: formData.country?.value,
        state: formData.state?.value,
        city: formData.city?.value,
      },
      email: {
        primary: formData.emailId,
      },
      ...(isEdit ? {} : { password: generatePassword() }),
      profilePhotoUrl: "https://api.dicebear.com/9.x/micah/svg?seed=Leo",
      // role: Number(formData.role.roleType) || 2, // Not decided so passing 2 for RA
      // designation: Number(formData.designation),
      team: Number(formData.team),
      teamRole: Number(formData.teamRole),
      // reportingTo: Number(formData.reportingTo.value),
      reportTo: Number(formData.reportingTo.value),
      // level: Number(formData.level),
      ...(formData.level ? { level: Number(formData.level) } : {}),
      pluginAccess: selectedPlugins,
      addedBy: user.data?.uiid,
      status: isEdit ? formData.status : status,
      // userDesignation : formData.userDesignation,
      designation: formData.designation,
      // roleId: formData.role.roleType,
      // roleId: formData.role.value,
      role: formData.role.value,
      userType: formData.userType,
      botAssignedTo: formData.botAssignedTo
      // role: formData.role.type,
    };

    try {
      setLoading(true);
      let res;
      if (isEdit && formData._id) {
        res = await updateUser({
          id: formData._id,
          payload: { $set: payload },
        });
      } else {
        res = await addUser({
          coll: "User",
          payload,
        });
      }
      if (res?.data) {
        window.dispatchEvent(new CustomEvent('recheckAiJobs'));
        if (isEdit) {
          showToast("User updated successfully!", "success", 2000);
          trackEvent({
            eventName: "User_Edited",
            props: {
              firstName: formData?.firstName,
            },
          });
        } else {
          trackEvent({
            eventName: "User_Added",
            props: {
              firstName: formData?.firstName,
            },
          });
          showToast("User added successfully!", "success", 2000);
          setFormData(initialFormData);
        }
        // navigate("/settings#access-control");
        navigate(
          "/settings?access-control=user-teams&settings=access-control#access-control",
        );
      } else {
        // showToast(res.error || "An error occured", "error", 2000);
        const errorMsg =
          typeof res?.error === "string" ? res?.error : "An error occurred";

        showToast(errorMsg, "error", 2000);
      }
    } catch (err) {
      console.error("Error adding user:", err);
    } finally {
      setLoading(false);
    }
  };
  const handlePlugins = (key) => {
    let newPlugins = [];
    if (selectedPlugins.includes(key)) {
      newPlugins = selectedPlugins.filter((item) => item !== key);
    } else {
      newPlugins = [...selectedPlugins, key];
    }

    setSelectedPlugins(newPlugins);
  };

  useEffect(() => {
    const fetchUser = async () => {
      if (isEdit && data?.uiid) {
        try {
          setLoading(true);
          const res = await getUser({
            coll: "User",
            fil: { uiid: { type: "IN", value: data.uiid } },
            // ref: "Role User"
            ref: "reportTo Role",
          });

          if (res?.data?.data) {
            const userData = res.data.data;
            // const roleObj = userData.role?.[0];
            const roleObj = userData.role;
            //         setFormData({
            //           firstName: userData.firstName || "",
            //           lastName: userData.lastName || "",
            //           emailId: userData.email?.primary || "",
            //           phone: userData.mobile?.primary || { code: "+91", number: "" },
            //           // country: { label: userData.address?.country, value: userData.address?.country },
            //           // state: { label: userData.address?.state, value: userData.address?.state },
            //           // city: { label: userData.address?.city, value: userData.address?.city },
            //           country: userData.address?.country
            //   ? { label: userData.address.country, value: userData.address.country }
            //   : "",
            // state: userData.address?.state
            //   ? { label: userData.address.state, value: userData.address.state }
            //   : "",
            // city: userData.address?.city
            //   ? { label: userData.address.city, value: userData.address.city }
            //   : "",
            //           designation: userData.designation || "",
            //           role: { value: userData.roleId }, // map properly
            //           // roleType: userData.roleType === 1 ? "ATS" : "Workforce", // example logic
            //           team: userData.team || "",
            //           reportingTo: { value: userData.reportingTo },
            //           level: userData.level || "",
            //           // teamRole: userData.teamRole || "",
            //           roleType: userData.roleType
            //   ? [userData.roleType === 1 ? "ATS" : "Workforce"]
            //   : [],

            // teamRole: userData.teamRole
            //   ? [String(userData.teamRole)]
            //   : [],
            //         });
            setFormData({
              _id: userData._id,
              firstName: userData?.firstName || "",
              lastName: userData?.lastName || "",
              emailId: userData.email?.primary || "",
              phone: userData.mobile?.primary || { code: "+1", number: "" },
              country: userData.address?.country
                ? {
                    label: userData.address.country,
                    value: userData.address.country,
                  }
                : "",
              state: userData.address?.state
                ? {
                    label: userData.address.state,
                    value: userData.address.state,
                  }
                : "",
              city: userData.address?.city
                ? { label: userData.address.city, value: userData.address.city }
                : "",
              designation: userData?.designation || "",
              // role: userData.role ? { value: userData.role } : null,
              // roleType: userData.roleType
              //   ? [userData.roleType === 1 ? "ATS" : "Workforce"]
              //   : [],
              //   roleType: roleObj
              // ? roleObj?.module === 1 ? "ATS" : "Workforce"
              // : "",
              userType: userData.userType,
              roleType: roleObj
                ? roleObj?.module === 2
                  ? "ATS"
                  : roleObj?.module === 3
                    ? "Workforce"
                    : roleObj?.module === 4
                      ? "Benchsales"
                      : ""
                : "ALL",
              role: roleObj
                ? { value: roleObj.uiid, label: roleObj.name }
                : null,
              team: userData.team || "",
              // reportingTo: `${userData.reportingTo?.[0]?.firstName || ""} ${userData.reportingTo?.[0]?.lastName || ""}`,
              // reportingTo: userData.reportingTo?.[0]
              // ? {
              //     value: userData.reportingTo[0].uiid,
              //     label: `${userData.reportingTo[0].firstName} ${userData.reportingTo[0].lastName}`,
              //   }
              // : null,
              reportingTo: userData.reportTo?.[0]
                ? {
                    value: userData.reportTo[0].uiid,
                    label: `${userData.reportTo[0].firstName} ${userData.reportTo[0].lastName}`,
                  }
                : null,
              // reportingTo: userData
              // ? userData.reportingTo
              // : null,
              level: userData.level || "",
              teamRole: userData.teamRole ? String(userData.teamRole) : "",
              status: userData.status,
              botAssignedTo: userData.botAssignedTo
            });

            // Set selected plugins
            setSelectedPlugins(userData.pluginAccess || []);
          }
        } catch (error) {
          console.error("Error fetching user:", error);
        } finally {
          setLoading(false);
        }
      }
    };

    fetchUser();
  }, [isEdit, data, setFormData]);


  return (
    <div className="flex flex-col gap-2 mt-4">
      <div className="flex items-center gap-2">
        {/* <Button
          // type="icon"
          variant="text"
          title={isEdit && isEdit ? "Edit User" : "Add User"}
          icon="arrow_left_alt"
          color="black"
          fromLeft
          className="self-start text-lg font-semibold !px-2"
          onClick={() => {
            if (returnTo) {
              navigate("/bs/benchsales/recruiters");
            } else {
              navigate(
                "/settings?access-control=user-teams&settings=access-control#access-control",
              );
            }
          }}
        /> */}
        <Button
          variant="text"
          title={isEdit ? "Edit User" : "Add User"}
          icon="arrow_left_alt"
          color="black"
          fromLeft
          className="self-start text-lg font-semibold !px-2"
          onClick={() => {
            if (returnTo) {
              navigate(returnTo);
            } else {
              navigate(-1); // fallback to browser back
            }
          }}
        />

        {/* <h6>{isEdit && isEdit ? "Edit" : "Add"} User</h6> */}
      </div>
      <div className="flex flex-col rounded shadow m-1 p-3">
        <h6>User Information</h6>
        <hr className="text-primary w-15 mt-1" />

        <div className="grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 gap-3 py-2">
          <FormFieldSet
            title="Creating User"
            type="radio"
            placeholder="Enter"
            name={uuidv4()}
            options={[
              {label:"User",value:1},
              {label:"Bot",value:2},
            ]}
            value={formData.userType}
            onChange={(e) => handleChange("userType", Number(e.target.value))}
            error={errors.userType}
            shadow={true}
            // required={true} 
            
          />
          <FormFieldSet
            title="First Name"
            type="text"
            placeholder="Enter"
            value={formData.firstName}
            onChange={(value) => handleChange("firstName", value)}
            error={errors.firstName}
            shadow={true}
            required={true}
          />
          <FormFieldSet
            title="Last Name"
            type="text"
            placeholder="Enter"
            value={formData.lastName}
            onChange={(value) => handleChange("lastName", value)}
            error={errors.lastName}
            shadow={true}
            required={true}
          />
          <FormFieldSet
            title="Email ID"
            type="text"
            placeholder="Enter"
            value={formData.emailId}
            onChange={(value) => handleChange("emailId", value)}
            error={errors.emailId}
            shadow={true}
            required={
              // isNormalUser
              true
            }
          />
          {/* <FormFieldSet
            title="Phone Number"
            // type="text"
            type="phoneNew"
            placeholder="Enter"
            // value={formData.phoneNumber}
            values={[formData.phone]}
            // onChange={(value) => handleChange("phone.number", value[0])}
            onChange={(value) => {
              // value[0] will be the phone object { code, number }
              handleChange("phone", value[0]);
            }}
            error={errors.phoneNumber}
            shadow={true}
          /> */}
          <FormFieldSet
            title="Phone Number"
            type="phone"
            placeholder="Enter Mobile Number"
            // value={
            //   formData.phone?.fullNumber ||
            //   (formData.phone?.code && formData.phone?.number
            //     ? `${formData.phone.code}${formData.phone.number}`
            //     : "")
            // }
            value={formData.phone?.number || ""}
            code={formData.phone?.code || ""}
            onChange={(fullValue, details) =>
              handleChange("phone", {
                code: details.countryCode,
                number: details.number,
                fullNumber: details.fullNumber,
              })
            }
            error={errors.phone}
            shadow={true}
            required
          />
          <div className="w-full">
            <FormFieldSet
              title="Country"
              // type="select"
              type="countriesUsAndCanada"
              placeholder="Select"
              // options={countrys}
              value={formData.country}
              onChange={(value) => handleChange("country", value)}
              error={errors.country}
              shadow={true}
              required={
                // isNormalUser
                true
              }
            />
          </div>
          <FormFieldSet
            title="State"
            showSearch
            type="states"
            // type="select"
            placeholder="Select"
            // options={states}
            value={formData.state}
            onChange={(value) => handleChange("state", value)}
            parentValue={{ country: formData?.country?.value }}
            disabled={!formData.country}
            error={errors.state}
            shadow={true}
          />
          <FormFieldSet
            title="City"
            // type="text"
            type="cities"
            showSearch
            placeholder="Enter"
            value={formData.city}
            onChange={(value) => handleChange("city", value)}
            error={errors.city}
            parentValue={{
              country: formData.country?.value,
              state: formData.state?.value,
            }}
            disabled={!formData.state}
            shadow={true}
          />
          <FormFieldSet
            title="Designation"
            type="select"
            placeholder="Select"
            options={designations}
            value={formData.designation}
            onChange={(value) => handleChange("designation", value)}
            error={errors.designation}
            shadow={true}
          />
          <FormFieldSet
            title="Level"
            type="select"
            placeholder="Select"
            options={levelOptions}
            value={formData.level}
            onChange={(value) => handleChange("level", value)}
            error={errors.level}
            shadow={true}
          />
          {/* <FormFieldSet
            title="User Designation"
            type="select"
            placeholder="Select"
            options={userDesignation}
            value={formData.userDesignation}
            onChange={(value) => handleChange("Userdesignations", value)}
            error={errors.userDesignation}
          /> */}
        </div>
      </div>

      <div className="grid grid-cols-2 gap-2">
        <div className="flex flex-col rounded shadow m-1 p-3">
          <h6>Role Selection</h6>
          <hr className="text-primary w-15 mt-1" />

          <div className="flex flex-col py-2">
            <FormFieldSet
              type="checkbox"
              //  type="radio"
              size="md"
              options={[
                { label: "ATS", value: "ATS" },
                {
                  label: "Workforce",
                  value: "Workforce",
                },
                {
                  label: "Benchsales",
                  value: "Benchsales",
                },
                {
                  label: "Non-IT Marketing",
                  value: "Non-IT_Marketing",
                },
              ].filter((option) =>
                isBenchUser ? option.value === "Benchsales" : true,
              )}
              values={formData.roleType}
              onChange={(value) => handleChange("roleType", value)}
              disabled={!isNormalUser}
              error={errors.roleType}
              noTitle
              multiple={false}
              required={true}
            />
            <div className="w-[50%] lg:w-[40%] xl:w-[30%] my-2">
              <FormFieldSet
                // type="select"
                type={
                  formData.roleType === "ATS"
                    ? "atsRoles"
                    : formData.roleType === "Workforce"
                      ? "workforceRoles"
                      : formData.roleType === "Benchsales"
                        ? "benchsalesRoles"
                        : formData.roleType === "Non-IT_Marketing"
                          ? "nonItMarketingRoles"
                          : []
                }
                title="Select Role"
                placeholder="Select"
                // options={roles}
                // options={
                //   formData.roleType === "ATS"
                //     ? atsRoles
                //     : formData.roleType === "Workforce"
                //     ? workforceRoles
                //     : []
                // }
                value={formData.role}
                onChange={(value) => {
                  // console.log("value",value)
                  handleChange("role", value);
                }}
                error={formData.roleType.length ? errors.role : null}
                disabled={!formData.roleType || !isNormalUser}
                shadow={true}
                required={
                  // isNormalUser
                  true
                }
              />
            </div>
          </div>
        </div>

        <div className="flex flex-col rounded shadow p-3">
          {/* <h6>Reporting To</h6>
          <hr className="text-primary w-15 mt-1" /> */}

          {/* <div className="flex flex-col py-2"> */}
          <div className="flex gap-5">
            <div className="md:w-[50%] lg:w-[30%] mb-5">
              <FormFieldSet
                // type="select"
                type="users"
                title="Reporting To"
                placeholder="Select"
                // options={teams}
                value={formData.reportingTo}
                onChange={(value) => {
                  handleChange("reportingTo", value);
                }}
                error={errors.reportingTo}
                shadow={true}
                showSearch
                required={
                  // isNormalUser
                  true}
              />
            </div>
            {formData?.userType == 2 && (
              <div className="w-[180px] min-w-[160px]">
                <FormFieldSet
                  // type="select"
                  type="onlyBDMUsers"
                  title="Assign Bot to BDM"
                  placeholder="Select"
                  // options={teams}
                  value={formData.botAssignedTo}
                  multiple
                  onChange={(value) => {
                    handleChange("botAssignedTo", value);
                  }}
                  error={errors.botAssignedTo}
                  shadow={true}
                  showSearch
                  required={
                    // isNormalUser
                    true}
                />
              </div>
            )}
          </div>
          <div className="flex md:flex-col lg:flex-row md:items-start lg:items-end gap-5">
            <div className="md:w-[50%] lg:w-[30%]">
              {!isBenchUser && (
                <FormFieldSet
                  type="select"
                  title="Select Team"
                  placeholder="Select"
                  options={teams}
                  value={formData.team}
                  onChange={(value) => handleChange("team", value)}
                  error={errors.team}
                  shadow={true}
                />
              )}
            </div>

            {!isBenchUser && (
              <FormFieldSet
                type="checkbox"
                // type="radio"
                size="md"
                // options={[
                //   { label: "Team Lead", value: "Team Lead" },
                //   {
                //     label: "Team Member",
                //     value: "Team Member",
                //   },
                // ]}
                options={[
                  { label: "Team Lead", value: "1" },
                  {
                    label: "Team Member",
                    value: "2",
                  },
                ]}
                values={formData.teamRole}
                // onChange={(value) => handleChange("reportingTo", value)}
                onChange={(val) => {
                  handleChange("teamRole", val);
                }}
                // onChange={(e) => handleChange("reportingTo",e.target)}
                error={errors.teamRole}
                noTitle
                multiple={false}
              />
            )}
          </div>
          {/* </div> */}
        </div>
      </div>

      <div className="flex flex-col rounded shadow m-1 p-3">
        <h6>Set Plugin Access Permissions</h6>
        <hr className="text-primary w-15 mt-1" />

        <div className="flex gap-3 my-3">
          {plugins.map((value, key) => (
            <Button
              key={key}
              className={`!border-gray-300 !text-black ${
                // selectedPlugins.includes(key) ? `!bg-primary-50` : `!bg-gray-50`
                selectedPlugins.includes(value.value)
                  ? `!bg-primary-50`
                  : `!bg-gray-50`
              }`}
              title={
                <div className="flex gap-3">
                  <img src={value.image} alt={`${value.lable} logo`} />
                  <span>{value.lable}</span>
                </div>
              }
              // onClick={() => handlePlugins(key)}
              onClick={() => handlePlugins(value.value)}
            />
          ))}
        </div>
      </div>

      <div className="flex gap-3 self-end mt-1">
        <Button
          title="Cancel"
          variant="outlined"
          onClick={() => navigate("/settings#access-control")}
        />
        {isEdit && isEdit ? (
          <Button title="Save" onClick={handleSubmit} />
        ) : (
          <>
            <Button
              title="Register"
              // onClick={handleSubmit}
              onClick={() => handleSubmit(2)}
            />
            <Button
              title="Register & Activate"
              // onClick={handleSubmit}
              onClick={() => handleSubmit(1)}
            />
          </>
        )}
      </div>
      <Backdrop isOpen={loading}>
        <LogoLoader />
      </Backdrop>
    </div>
  );
};

export default AddUser;
